import React, { useEffect, useState } from "react";
import { filesize } from "filesize";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import ReactStars from "react-stars";
import DatePicker from "react-datepicker";
import { uploadToS3 } from "../../api/apiService";
import {
  FaAngleRight,
  FaCloudUploadAlt,
  FaFileAlt,
  FaFileUpload,
  FaHome,
  FaImage,
  FaPlusCircle,
  FaRegTimesCircle,
  FaRemoveFormat,
  FaSearch,
  FaTrashAlt,
  FaXbox,
} from "react-icons/fa";
import Loading from "../../images/loading.gif";
import {
  useSelector,
  useDispatch,
  useLocation,
  useNavigate,
} from "../../components/hooks/hooks";
import { awsConfig } from "../../config";
import AWS from "aws-sdk";
import { ToastContainer, toast } from "react-toastify";
import { backendApi,backendApiForInterviewQtn } from "../../api/apiService";
import { setAwsConfigData } from "../../redux/reducers/masterDataSlice";
import Select from "react-select";
import LoaderImage from "../../images/spinner.gif";
export default function ResumeUpload() {
  //   const reduxState = useSelector((state) => state.yourReducerName);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { awsData, recuitmentStatus } = useSelector(
    (state) => state.commonData
  );

  const commonData = useSelector((state) => state.commonData);
  const login = useSelector((state) => state.login);
  const { userData, userDetails, userId, siteId } = useSelector(
    (state) => state.login
  );
  const [htmlContent, setHtmlContent] = useState("");
  const [awsConfigDataState, setAwsConfigDataState] = useState(awsConfig);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [gender, setGender] = useState("");
  const [applicationStatus, setApplicationStatus] = useState("");
  const [dob, setDob] = useState(null);
  const [address, setAddress] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [docLink, setDocLink] = useState("");
  const [docName, setDocName] = useState("");
  const [docSize, setDocSize] = useState("");
  const [totalExperience, setTotalExperience] = useState("");
  const [ctc, setCtc] = useState("");
  const [ectc, setEctc] = useState("");
  const [locality, setLocality] = useState("");
  const [preferredLocation, setPreferredLocation] = useState("");
  const [relocate, setRelocate] = useState("");
  const [noticePeriod, setNoticePeriod] = useState("");
  const [experienceValue, setExperienceValue] = useState("");
  const [educationValue, setEducationValue] = useState("");
  const [remarks, setRemarks] = useState("");
  const [status, setStatus] = useState("");
  // const [educationValue, setEducationValue] = useState("");
  const [docView, setDocView] = useState(false);
  const [htmlView, setHtmlView] = useState(false);
  const [educationArray, setEducationArray] = useState([]);
  const [experienceArray, setExperienceArray] = useState([]);
  const [skillsArray, setSkillsArray] = useState([]);
  const [popupHide, setPopupHide] = useState(false);
  const [skillName, setSkillName] = useState("");
  const [isPdf, setIsPdf] = useState(false);
  const [activeNoticePeriod, setActiveNoticePeriod] = useState(1);
  // const [starValue, setStarValue] = useState("");
  const [data, setData] = useState([]);
  const [experience, setExperience] = useState();
  const [skillId, setSkillId] = useState([]);
  const [skillValues, setSkillValues] = useState("");
  const [resumeText, setResumeText] = useState("");
  const [newSkill, setNewSkill] = useState("");
  const [resumeSource, setResumeSource] = useState("");
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refreshValue, setRefreshValue] = useState(false);
  const [isloading, setIsloading] = useState(false);

  var s3;
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("ResumeUploadMenu")?.classList.add("active");
    }, 500);
    initialData();
  }, []);

  const initialData = () => {
    const apiReq = {
      functionName: "candidateInit",
      site_id: "1",
    };
    backendApi(apiReq).then((data) => {
      if (data.success === "1") {
        const transformedOptions = data.skill.map((item) => ({
          value: item.id,
          label: item.skill_name,
        }));
        // setSkillsArray(
        //   data.skill.map((obj) => ({
        //     ...obj,
        //     checked: false,
        //     starValue: 0,
        //     experience: "",
        //   }))
        // );
        setSkillValues(transformedOptions);
      } else {
        setSkillsArray([]);
        toast.warn("Something went wrong!!", { containerId: "D" });
      }
    });
  };
  const saveQuestions = (extractedQuestions,candidateId) => {
    const apiReq = {
      "functionName": "saveQuestion",
      "question": extractedQuestions,
      "candidateId": candidateId,
      "createdBy": userId,
    }
    backendApiForInterviewQtn(apiReq).then((data) => {
      console.log("saveeeee",data)
      setTimeout(() => {
        window.location.reload();
    }, 2000);
    setIsloading(false);

    })
  }
  const handleFileUpload = async (e) => {
    const allowedFileTypes = [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
    ];
    const files = e.target.files[0];
    console.log(files, "files");

    e.target.value = null;
    if (files) {

      // Check if the selected file type is allowed
      if (allowedFileTypes.includes(files.type)) {
        console.log(
          "🚀 ~ file: resumeUpload.jsx:37 ~ handleFileUpload ~ files:",
          files
        );
        console.log(
          "🚀 ~ file: resumeUpload.jsx:124 ~ handleFileUpload ~ s3:",
          s3
        );
        // return false;
        setLoading(true);
        document.body.classList.add("overflow-hidden");
        try {
          // const bucketParams = {
          //   Bucket: awsConfigDataState.s3Bucket,
          // };
          // AWS.config.update({
          //   accessKeyId: "AKIAS3OQS5BMJOLTJSNF",
          //   secretAccessKey: "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",
          //   region: "us-east-1",
          // });
          // s3 = new AWS.S3({
          //   apiVersion: "2006-03-01",
          //   params: bucketParams,
          // });
          // console.log("awsConfigDataState", awsConfigDataState);
          // console.log("s3", s3);

          // const data = await s3
          //   .upload({
          //     Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${files.name}`,
          //     Body: files,
          //     ACL: "public-read",
          //   })
          //   .promise();
          const data = await uploadToS3(files);
         // return s3Url;
          console.log("Pathhh", data);
          const prompt = `This is an extract of a resume find the name of the person,address,number,email,skills,total experience,gender if gender or sex is specified and date of birth from this 
          text without code and prefix just in this format   {
            "name":"",
            "address":"",
            "number":"",
            "email":"",
            "skills":["","","",],
            "experience":"",
            "gender":"",
            "dob":""
          } which can be json parsed and dont mind if there are no values for the above mentioned parameters just give me the object which can be json parsed`;
          let apiReq;
          const fileType = data.split(".").pop().toLowerCase();
          if (fileType === "pdf") {
            apiReq = {
              functionName: "pdfDataExtraction",
              file_url: data,
            };
          } else {
            apiReq = {
              functionName: "wordDataExtraction",
              file_url: data,
            };
          }
          backendApi(apiReq).then((data) => {
            if (data.success === "1") {
              console.log("ressss", data);
              if (data.textContent == "\n\n") {
                toast.warn("Invalid pdf/docx try another one", {
                  containerId: "D",
                });
                setDocLink("");
                setLoading(false);
                document.body.classList.remove("overflow-hidden");
              } 
              else {
                setResumeText(data.textContent);
                const req = {
                  functionName: "chatGpt_openai",
                  site_id:siteId,
                  prompt: `${data.textContent}+${prompt}`,
                };
                console.log("reqqqqqqq", req);
                backendApi(req).then((data) => {
                  setRefreshValue(true);
                  if (data.success === "1") {
                    console.log(
                      "data.choices[0]...........",
                      data.data.choices[0].text
                    );
                    let parsedData;
                    if (
                      data.data.choices[0].message.content
                        .trim()
                        .toLowerCase()
                        .startsWith("answer:")
                    ) {
                      const jsonStartIndex =
                        data.data.choices[0].message.content.indexOf("{");
                      const jsonString =
                        data.data.choices[0].message.content.substring(
                          jsonStartIndex
                        );
                      try {
                        parsedData = JSON.parse(jsonString);
                        setFirstName(parsedData?.name);
                        setPhoneNo(parsedData?.number);
                        setEmailId(parsedData?.email);
                        setGender(parsedData?.gender);
                        setDob(parsedData?.dob);
                        setAddress(parsedData?.address);
                        setExperience(parsedData?.experience);
                        setTotalExperience(parsedData?.experience);
                        setSkillsArray(parsedData.skills);
                      } catch (error) {
                        console.error("Error parsing JSON:", error);
                        toast.warn(
                          "Something went wrong!Please try the refresh option",
                          { containerId: "D" }
                        );
                      }
                    } else {
                      try {
                        parsedData = JSON.parse(
                          data.data.choices[0].message.content
                        );
                        setFirstName(parsedData?.name);
                        setPhoneNo(parsedData?.number);
                        setEmailId(parsedData?.email);
                        setGender(parsedData?.gender);
                        setDob(parsedData?.dob);
                        setAddress(parsedData?.address);
                        setExperience(parsedData?.experience);
                        setTotalExperience(parsedData?.experience);
                        setSkillsArray(parsedData.skills);
                      } catch (error) {
                        console.error("Error parsing JSON:", error);
                        toast.warn(
                          "Something went wrong!Please try the refresh option",
                          { containerId: "D" }
                        );
                      }
                    }
                  } else {
                    toast.warn(
                      data.errorMessage || "Something went wrong!Please try the refresh option",
                      { containerId: "D" }
                    );
                  }
                  setLoading(false);
                  document.body.classList.remove("overflow-hidden");
                });
          
                    
              }
            } else {
              toast.warn("Something went wrong! Please try the refresh option", {
                containerId: "D",
              });
              setLoading(false);
              document.body.classList.remove("overflow-hidden");
            }
          });
          setDocName(files.name);
          setDocSize(filesize(files.size, { base: 10 }).toString());
          setDocLink(data);
          setDocView(true);
          const isPdf = data.endsWith(".pdf");
          setIsPdf(isPdf);
          setTimeout(() => {
            setHtmlView(true);
          }, 1000);

          // Wait for pictureDbSave to complete and save each path one by one
          // await pictureDbSave(data.Location);
        } catch (err) {
          console.error("err", err);
          // Handle the error, show a toast notification, or update state accordingly
          return;
        }
      } else {
        toast.warn("Please upload a valid Word (.docx) or PDF file.", {
          containerId: "D",
        });
        setLoading(false);
        document.body.classList.remove("overflow-hidden");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  };
  const formatSize = (bytes) => {
    return filesize(bytes, { base: 10 }).toString();
    // if (bytes > 1000 * 1024) {
    //   return filesize(bytes, { base: 10 });
    // } else {
    //   return filesize(bytes, { base: 10, output: "object" }).to("KB");
    // }
  };
  useEffect(() => {
    if (awsConfigDataState) {
      console.log(
        "🚀 ~ file: resumeUpload.jsx:151 ~ useEffect ~ awsConfigDataState:",
        awsConfigDataState
      );

      if (awsData !== "default") dispatch(setAwsConfigData(awsConfigDataState));
      const bucketParams = {
        Bucket: awsConfigDataState.s3Bucket,
      };
      AWS.config.update({
        region: "us-east-1",
      });
      s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: bucketParams,
      });
      console.log("🚀 ~ file: resumeUpload.jsx:169 ~ useEffect ~ s3:", s3);
    }
  }, []);
  const deleteFile = () => {
    setDocLink("");
    setDocName("");
    setDocSize("");
    setDocView(false);
    setHtmlView(false);
  };

  const addRemoveExperience = (value, mode) => {
    if (value === "") {
      toast.warn("Please enter experience", { containerId: "D" });
      return false;
    }

    if (mode === "add") {
      setExperienceArray((experience) => [...experience, value]);
      setExperienceValue("");
    } else {
      let array = experienceArray.filter((obj) => obj !== value);
      setExperienceArray(array);
    }
  };
  const addRemoveEducation = (value, mode) => {
    if (value === "") {
      toast.warn("Please enter experience", { containerId: "D" });
      return false;
    }

    if (mode === "add") {
      setEducationArray((education) => [...education, value]);
      setEducationValue("");
    } else {
      let array = educationArray.filter((obj) => obj !== value);
      setEducationArray(array);
    }
  };
  const toggleChecked = (id) => {
    const updatedSkillsArray = skillsArray.map((skill) => {
      if (skill.id === id) {
        return { ...skill, checked: !skill.checked }; // Toggle the "checked" property
      }
      return skill;
    });

    setSkillsArray(updatedSkillsArray); // Update the state
  };
  const saveSkill = () => {
    if (skillName === "") {
      toast.warn("Skill name cannot be empty", { containerId: "D" });
      return false;
    }
    const apiReq = {
      functionName: "saveSkill",
      site_id: "1",
      skill_name: skillName,
    };
    backendApi(apiReq).then((data) => {
      if (data.success === "1") {
        toast.success("New Skill added successfully", { containerId: "D" });
        setPopupHide(false);
        initialData();
        setSkillName("");
      }
    });
  };
  const onStarClick = (e, id) => {
    console.log("🚀 ~ file: resumeUpload.jsx:233 ~ onStarClick ~ e:", e);
    const updatedSkillsArray = skillsArray.map((skill) => {
      if (skill.id === id) {
        return { ...skill, starValue: e }; // Toggle the "checked" property
      }
      return skill;
    });

    setSkillsArray(updatedSkillsArray); // Update the state
    // setStarValue(e);
  };
  const expSelect = (e, id) => {
    console.log("🚀 ~ file: resumeUpload.jsx:233 ~ onStarClick ~ e:", e);
    const updatedSkillsArray = skillsArray.map((skill) => {
      if (skill.id === id) {
        return { ...skill, experience: e.target.value }; // Toggle the "checked" property
      }
      return skill;
    });

    setSkillsArray(updatedSkillsArray); // Update the state
  };
  const validate = () => {
    if (firstName.trim() === "") {
      toast.warn("First Name required", { containerId: "D" });
      return false;
    } else if (emailId.trim() === "") {
      toast.warn("Email  required", { containerId: "D" });
      return false;
    } else if (phoneNo.trim() === "") {
      toast.warn("Phone No. required", { containerId: "D" });
      return false;
    } else if (docLink.trim() === "") {
      toast.warn("Resume required", { containerId: "D" });
      return false;
    }
    return true;
  };
  const saveForm = () => {
    let filteredSkills = skillsArray
      .filter((obj) => obj.checked == true)
      .map((obj) => ({
        skill_id: obj.id,
        rating: obj.starValue,
        experience: obj.experience,
      }));
    console.log(
      "🚀 ~ file: resumeUpload.jsx:293 ~ saveForm ~ skillsArray:",
      filteredSkills
    );
    if (validate() === false) return false;
    let noticePeriod = "";
    if (activeNoticePeriod == 1) noticePeriod = "1 Month";
    if (activeNoticePeriod == 2) noticePeriod = "2 Month";
    if (activeNoticePeriod == 3) noticePeriod = "3 Month";
    if (activeNoticePeriod == 4) noticePeriod = "4 Month";
    let remark = remarks.replace(/['"]/g, "\\$&");
    setIsloading(true);
    const apiSave = {
      functionName: "candidateSave",
      site_id: window.localStorage.getItem("siteId"),
      full_name: firstName,
      email_id: emailId,
      mobile_no: phoneNo,
      sec_contact_no: "",
      total_experiance: totalExperience,
      ctc: ctc,
      ectc: ectc,
      location: locality,
      preferredLocation: preferredLocation,
      relocate: relocate,
      notice_period: noticePeriod,
      remarks: remark,
      status: applicationStatus ? applicationStatus : "",
      created_by: userId,
      address: address,
      resume_url: docLink,
      resume_text: resumeText,
      skillSet: skillsArray,
      dob: dob,
      gender: gender,
      source: resumeSource,
    };
    console.log("apiSave", apiSave);
    backendApi(apiSave)
      .then((data) => {
        toast.success("Saved Successfully", { containerId: "D" });
        console.log("dataaaaaaaaaaaaaaa",data)
        if(data.success == '1' && data.candidateId){
         const promptforQuestiongeneration = `
                This is an extract of a resume. Generate 5 meaningful interview questions based on the skills, experience, and details mentioned in the following text and each question should be inside {}:
                ${resumeText}.
                The questions should focus on understanding the candidate's expertise, experience, and problem-solving ability.`;
                    const req1 = {
                      functionName: "chatGpt_openai",
                      site_id:siteId,
                      prompt: `${resumeText}+${promptforQuestiongeneration}`,
                    };
                    backendApi(req1).then((dataa) => {
                    if (dataa.success === "1") {
                      const questions = dataa.data.choices[0].message.content.trim();
                      console.log("Generated Questions:", questions);
                      const regex = /\{\d+\.\s(.*?)\}/g;
                      let match;
                      const extractedQuestions = [];
                  
                      while ((match = regex.exec(questions)) !== null) {
                          extractedQuestions.push(match[1]); 
                      }
                      
                      if (extractedQuestions.length > 0) {
                        saveQuestions(extractedQuestions, data.candidateId);
        
                        // Reload after saving
                        
                    }
                      console.log("Generated Questions:111111111111111111", extractedQuestions);
                    }})
        }
        else{
          setIsloading(false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
       
      })
      // .finally(() => {
      //   setIsloading(false);
      // });
  };

  const handleRemoveSkill = (indexToRemove, skillToRemove) => {
    // Create a new array without the specified skill
    const newData = data.map((item, index) => {
      if (index === indexToRemove) {
        return {
          ...item,
          skills: item.skills.filter((skill) => skill !== skillToRemove),
        };
      }
      return item;
    });

    // Update the state with the new data
    setData(newData);
  };

  const handleSkillSelectChange = (selectedOption) => {
    setSkillId(selectedOption);
    const selectedOptions = selectedOption.map((item) => String(item.label));
    setData(selectedOptions);
    console.log(selectedOptions);
  };

  const addSkills = () => {
    if (newSkill.trim() === "") {
      toast.warn("Skill added is empty", { containerId: "D" });
      return;
    } else {
      setSkillsArray((prevArray) => [...prevArray, newSkill]);
      setNewSkill("");
    }
  };

  const handleRemoveSkills = (index) => {
    const updatedSkills = [...skillsArray];
    updatedSkills.splice(index, 1);
    setSelectedSkill(null);
    setSkillsArray(updatedSkills);
  };

  const refresh = () => {
    setLoading(true);
    const prompt = `This is an extract of a resume find the name of the person,address,number,email,skills,total experience,gender if gender or sex is specified and date of birth from this 
    text without code and prefix just in this format  {
      "name":"",
      "address":"",
      "number":"",
      "email":"",
      "skills":["","","",],
      "experience":"",
      "gender":"",
      "dob":""
    } which can be json parsed and dont mind if there are no values for the above mentioned parameters just give me the object which can be json parsed  `;
    const req = {
      functionName: "chatGpt_openai",
      site_id:siteId,
      prompt: `${resumeText}+${prompt}`,
    };
    backendApi(req).then((data) => {
      if (data.success === "1") {
        console.log("data.choices[0]...........", data.data.choices[0].text);
        let parsedData;
        if (
          data.data.choices[0].message.content
            .trim()
            .toLowerCase()
            .startsWith("Answer:")
        ) {
          const jsonStartIndex =
            data.data.choices[0].message.content.indexOf("{");
          const jsonString =
            data.data.choices[0].message.content.substring(jsonStartIndex);
          try {
            parsedData = JSON.parse(jsonString);
            setFirstName(parsedData?.name);
            setPhoneNo(parsedData?.number);
            setEmailId(parsedData?.email);
            setGender(parsedData?.gender);
            setDob(parsedData?.dob);
            setAddress(parsedData?.address);
            setExperience(parsedData?.experience);
            setTotalExperience(parsedData?.experience);
            setSkillsArray(parsedData.skills);
          } catch (error) {
            console.error("Error parsing JSON:", error);
            toast.warn(data.errorMessage || "Something went wrong!Please try the refresh option", {
              containerId: "D",
            });
          }
        } else {
          try {
            parsedData = JSON.parse(data.data.choices[0].message.content);
            setFirstName(parsedData?.name);
            setPhoneNo(parsedData?.number);
            setEmailId(parsedData?.email);
            setGender(parsedData?.gender);
            setDob(parsedData?.dob);
            setAddress(parsedData?.address);
            setExperience(parsedData?.experience);
            setTotalExperience(parsedData?.experience);
            setSkillsArray(parsedData.skills);
          } catch (error) {
            console.error("Error parsing JSON:", error);
            toast.warn(data.errorMessage || "Something went wrong!Please try the refresh option", {
              containerId: "D",
            });
          }
        }
      } else {
        toast.warn(data.errorMessage || "Something went wrong!Please try the refresh option", {
          containerId: "D",
        });
      }
      setLoading(false);
    });
  };
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  return (
    <>
      {/* <div className="main-wrapper">
        <div className="top-color"></div>

        <ToastContainer
          enableMultiContainer
          containerId={"D"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Resume Upload"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container">
            <div className="xilliWrap"> */}
      {loading && (
        <div className="loader-div">
          <img src={LoaderImage} alt="Loader" className="loader" />
        </div>
      )}
      <div className="card main-card">
        <div className="card-body">
          <div className="fileUpload">
            {/* <input type="file" className="default-file-input" > */}
            <label className="label " style={{ width: "100%" }}>
              <div className="upload-files-container">
                <div className="drag-file-area">
                  <span className="material-icons-outlined upload-icon">
                    <FaCloudUploadAlt />
                  </span>
                  <h3 className="dynamic-message">
                    {" "}
                    Upload your resume here{" "}
                  </h3>
                  <span className="reBrowse">
                    <label className="label">
                      <span className="browse-files">
                        <input
                          type="file"
                          className="default-file-input"
                          onChange={(e) => {
                            handleFileUpload(e);
                            e.target.value = null;
                          }}
                        />
                        <span className="browse-files-text">
                          {" "}
                          browse file
                        </span>{" "}
                        <span>from device</span>{" "}
                      </span>
                    </label>
                  </span>
                </div>
                <span className="cannot-upload-message">
                  {" "}
                  <span className="material-icons-outlined">
                    error
                  </span>{" "}
                  Please select a file first{" "}
                  <span className="material-icons-outlined cancel-alert-button">
                    cancel
                  </span>{" "}
                </span>
                {docView && (
                  <div className="file-block">
                    <div className="file-info">
                      {" "}
                      <span className="file-name">
                        <FaFileAlt /> {docName} |{" "}
                        <span className="file-size"> {docSize} </span>{" "}
                      </span>
                      <span className="material-icons remove-file-icon">
                        <FaTrashAlt onClick={() => deleteFile()} />
                      </span>
                    </div>
                  </div>
                )}

                {/* <button
                      type="button"
                      className="upload-button"
                      onClick={() => fileDisplay()}
                    >
                      {" "}
                      Upload{" "}
                    </button> */}
              </div>
            </label>
            {/* </input> */}
          </div>

          <div className="resumeForm">
            <div className="row">
              <div className="col-md-6">
                <div className="resumeWrap">
                  <div className="row">
                    <div className="col-md-8">
                      <h3 className="sub-head">Basic Details</h3>
                    </div>
                    <div className="col-md-4 refresh">
                      {refreshValue && (
                        <button
                          type="button"
                          className=" btn-btn btn btn-btn1 btn-sm"
                          onClick={() => refresh()}
                          style={{ fontSize: "14px" }}
                        >
                          Refresh
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Full Name<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="text"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          placeholder="Name"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          placeholder="Address"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Email Id<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="text"
                          value={emailId}
                          onChange={(e) => setEmailId(e.target.value)}
                          placeholder="Email "
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Phone No<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="text"
                          value={phoneNo}
                          onChange={(e) => setPhoneNo(e.target.value)}
                          placeholder="Phone "
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">Gender</label>
                        {/* <select
                              className="form-control"
                              value={gender}
                              onChange={(e) => setGender(e.target.value)}
                            >
                              <option value="">-Select-</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                            </select> */}
                        <input
                          type="text"
                          value={gender}
                          onChange={(e) => setGender(e.target.value)}
                          placeholder="Gender "
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">Dob</label>
                        {/* <DatePicker
                              className="form-control"
                              value={dob}
                              onChange={(date) => setDob(date)}
                              showMonthDropdown
                              showYearDropdown
                              maxDate={
                                new Date(
                                  new Date().getFullYear() - 18,
                                  new Date().getMonth(),
                                  new Date().getDate()
                                )
                              }
                            /> */}
                        <input
                          type="text"
                          value={dob}
                          onChange={(e) => setDob(e.target.value)}
                          placeholder="DOB"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <hr class="horizontal dark mt-1"></hr>
                  {/* <hr></hr> */}
                  <h3 className="sub-head">Office Details</h3>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Total Experience
                        </label>
                        <input
                          type="text"
                          value={totalExperience}
                          onChange={(e) =>
                            setTotalExperience(e.target.value)
                          }
                          placeholder="Yrs"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">CTC</label>
                        <input
                          type="text"
                          value={ctc}
                          onChange={(e) => setCtc(e.target.value)}
                          placeholder="CTC"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Expected CTC
                        </label>
                        <input
                          type="text"
                          value={ectc}
                          onChange={(e) => setEctc(e.target.value)}
                          placeholder="Expected CTC"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">Location</label>
                        <input
                          type="text"
                          value={locality}
                          onChange={(e) => setLocality(e.target.value)}
                          placeholder="Location"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Preferred Location
                        </label>
                        <input
                          type="text"
                          value={preferredLocation}
                          onChange={(e) =>
                            setPreferredLocation(e.target.value)
                          }
                          placeholder="Preferred Location"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Willing to Relocate?
                        </label>
                        <input
                          type="text"
                          value={relocate}
                          onChange={(e) => setRelocate(e.target.value)}
                          placeholder="Relocate"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Notice Period
                        </label>
                        {/* <input
                              type="text"
                              value={noticePeriod}
                              onChange={(e) => setNoticePeriod(e.target.value)}
                              placeholder="Notice Period"
                              className="form-control"
                            /> */}
                        <div className="noticePer">
                          <span
                            className={`skill-span  me-1 ${activeNoticePeriod === 1 && "active"
                              }`}
                            onClick={() => setActiveNoticePeriod(1)}
                          >
                            1 Month
                          </span>
                          <span
                            className={`skill-span  me-1 ${activeNoticePeriod === 2 && "active"
                              }`}
                            onClick={() => setActiveNoticePeriod(2)}
                          >
                            2 Month
                          </span>
                          <span
                            className={`skill-span me-1 ${activeNoticePeriod === 3 && "active"
                              }`}
                            onClick={() => setActiveNoticePeriod(3)}
                          >
                            3 Month
                          </span>
                          <span
                            className={`skill-span me-1 ${activeNoticePeriod === 4 && "active"
                              }`}
                            onClick={() => setActiveNoticePeriod(4)}
                          >
                            4 Month
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group dflexClm">
                        <label className="form-label">
                          Application Status
                        </label>
                        <select
                          className="form-control"
                          value={applicationStatus}
                          onChange={(e) =>
                            setApplicationStatus(e.target.value)
                          }
                        >
                          <option value="">-Select-</option>
                          {recuitmentStatus?.length > 0 &&
                            recuitmentStatus?.map((data) => {
                              return (
                                <>
                                  <option value={data}>{data}</option>
                                </>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group dflexClm mb-0">
                        <label className="form-label">
                          Remarks(if any)
                        </label>
                        <textarea
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                          placeholder="Remarks"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  {/* <hr></hr> */}
                  <hr class="horizontal dark"></hr>
                  <h3 className="sub-head">Key Skills</h3>
                  <div className="row mb-2">
                    <div className="col-md-8 col-10">
                      <input
                        type="text"
                        value={newSkill}
                        onChange={(e) => setNewSkill(e.target.value)}
                        placeholder="Add skill"
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 col-2 dFlexCenter">
                      <FaPlusCircle onClick={addSkills} />
                    </div>
                  </div>
                  {/* <Select
                        isMulti
                        name="colors"
                        placeholder="Add Skill"
                        options={skillValues}
                        value={skillId}
                        onChange={handleSkillSelectChange}
                        //styles={{ option: (base) => ({ ...base, fontSize: "13px" }) }}
                        //   styles={customStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                      {data?.length > 0 &&<button onClick={addSkills}>Add</button>} */}
                  <div className="noticePer skillsSpan">
                    {skillsArray?.length > 0 &&
                      skillsArray.map((data, i) => {
                        return (
                          <span className="skill-span me-1 mb-1">
                            {data}
                            <span
                              className="removeSkill"
                              onClick={() => handleRemoveSkills(i)}
                            >
                              &#10006;
                            </span>
                          </span>
                        );
                      })}
                  </div>
                  <hr class="horizontal dark"></hr>
                  <h3 className="sub-head">Source of Resume</h3>
                  <div className="row">
                    <div className="col-md-8 col-10">
                      <input
                        type="text"
                        value={resumeSource}
                        onChange={(e) =>
                          setResumeSource(e.target.value)
                        }
                        placeholder="Add source"
                        className="form-control"
                      />
                    </div>
                  </div>
                  {/* <hr></hr> */}
                  <hr class="horizontal dark"></hr>
                  <h3 className="sub-head">Experience {""}</h3>
                  {experience && (
                    <div className="noticePer">
                      <span className="skill-span me-1">
                        {experience}
                      </span>
                    </div>
                  )}
                  {/* <div className="skills">
                        <div className="dflexClm form-group ">
                          <form className="row">
                            {skillsArray.length > 0 &&
                              skillsArray.map((data, i) => {
                                return (
                                  <>
                                    <div className="col-md-6 form-group">
                                      <input
                                        type="checkbox"
                                        id={data.id}
                                        checked={data.checked}
                                        onClick={(e) => toggleChecked(data.id)}
                                      />
                                      <label for={data.id}>
                                        {data.skill_name}
                                      </label>
                                      <span className="reskllwrap">
                                        {data.checked && (
                                          <>
                                            <span className="reSkillsStar">
                                              <ReactStars
                                                count={5} // Number of stars
                                                value={data.starValue} // Initial rating value
                                                size={18} // Size of the stars (in pixels)
                                                color1={"#808080"} // Inactive star color
                                                color2={"#FFD700"} // Active star color
                                                edit={true} // Whether the user can change the rating
                                                half={true} // Enable half-star ratings
                                                onChange={(e) =>
                                                  onStarClick(e, data.id)
                                                } // Callback function when a rating changes
                                              />
                                            </span>
                                            <span className="reSkillSelect">
                                              <select
                                                name="skillExp"
                                                id="skillExp"
                                                className="form-control"
                                                onChange={(e) =>
                                                  expSelect(e, data.id)
                                                }
                                              >
                                                <option value="">Select</option>
                                                <option value="1-2">1-2</option>
                                                <option value="2-3">2-3</option>
                                                <option value="3-4">3-4</option>
                                                <option value="4-5">4-5</option>
                                                <option value="5-6">5-6</option>
                                                <option value="6-7">6-7</option>
                                                <option value="7-8">7-8</option>
                                                <option value="8-9">8-9</option>
                                                <option value="9-10">
                                                  9-10
                                                </option>
                                                <option value="10+">10+</option>
                                              </select>
                                            </span>

                                          </>
                                        )}
                                      </span>
                                    </div>
                                  </>
                                );
                              })}
                          </form>
                        </div>
                      </div> */}
                </div>

                {docLink && (
                  <div className="row justify-content-end px-0 py-3">
                    <button
                      type="button"
                      className=" btn-btn btn btn-btn2 btn-sm"
                      onClick={() => saveForm()}
                      style={{
                        fontSize: "14px",
                        minWidth: "110px",
                        maxWidth: "110px",
                      }}
                    >
                      {" "}
                      {isloading ? (
                        <img
                          src={Loading}
                          alt="loaderImg"
                          width={20}
                          height={20}
                        ></img>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <div className="resumeWrap" style={{ height: "97%" }}>
                  <h3 className="sub-head">Basic Details</h3>
                  {htmlView && (
                    <>
                      <iframe
                        src={
                          isPdf
                            ? `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                              docLink
                            )}`
                            : `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                              docLink
                            )}`
                        }
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ height: "inherit" }}
                      ></iframe>
                    </>
                    // <iframe
                    //   src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                    //     docLink
                    //   )}`}
                    //   width="100%"
                    //   height="600"
                    //   frameBorder="0"
                    //   allowfullscreen="false"
                    // ></iframe>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {popupHide && (
        <div className="modal_parent" id="addPeople">
          <div className="module_popup addPeople bfAddPeople">
            <div className="module_innerpopup module_bodypop">
              <div className="module_headdiv">
                <h4 className="popup_head">Add Skills</h4>
                <div className="module_close">
                  {/* <Icon.X color="grey" size={18} /> */}
                </div>
              </div>
              <div
                className="module_body"
                style={{ overflowX: "hidden" }}
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-group input-group-outline mb-2 location_search">
                      <label htmlFor="" className="formLabel">
                        Skill
                      </label>
                      <div className="col-md-12 p-0 position-relative">
                        <input
                          type="text"
                          value={skillName}
                          onChange={(e) => setSkillName(e.target.value)}
                          className="form-control"
                          placeholder="Enter Skill..."
                        />
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>

              <div className="childIssueses">
                <button
                  className="btn btn-save"
                  onClick={() => saveSkill()}
                >
                  Add
                </button>
                <button
                  className="btn btn-cancel"
                  onClick={() => {
                    setPopupHide(false);
                    setSkillName("");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
